import { getOptionPureText } from '@gp/utils/select';

export const formatOptions = (
  options?: IGPSelectOptionWithGroup[] | null,
  props?: {
    searchable?: boolean;
    searchValue?: string;
    optionTextRenderer?: IGPSelectOptionTextRenderer;
  },
): IGPSelectOptionWithGroup[] => {
  if (!Array.isArray(options) || !options.length) return [];
  const { searchable, searchValue, optionTextRenderer } = props || {};

  return options.map((option) => {
    const { text } = option || {};
    const pureText = getOptionPureText(option);
    const optionTmp = { ...option, label: pureText };
    const textTmp = optionTextRenderer?.(optionTmp, { highlightable: searchable, highlightText: searchValue }) ?? text;
    return { ...optionTmp, text: textTmp };
  });
};
